export default {
  header: 'Importuj znaczenia',
  selectFile: {
    placeholder: 'Wybierz źródło',
    selected: 'Źródło',
  },
  verifyMapping: {
    headline: 'Sprawdź właściwości',
    selectAttributes: 'Właściwości do zaimportowania',
    doImport: 'Importuj wybrane znaczenia',
  },
  migrateProgress: {
    headline: 'Importuj znaczenia',
  },
  warning: {
    text: 'Zmiany wprowadzone podczas migracji są nieodwracalne. Zaleca się wcześniejsze pobranie kopii zapasowej niestandardowych znaczeń. Tę kopię zapasową można później zaimportować w celu przywrócenia bieżącego stanu',
    downloadBackup: 'Pobierz kopię zapasową',
  },
  next: 'Następny',
  prev: 'Poprzedni',
};
